/**
 * OperationBadge Component - Epic 38 - Story 38.1
 *
 * Badge colorido para tipo de operação (CREATE/UPDATE/DELETE/UPLOAD)
 * com ícones e suporte a dark mode
 */

import React from 'react';
import { Plus, Edit, Trash2, Upload, FileDown, RefreshCw, CheckCircle, RotateCcw, MoreHorizontal, AlertTriangle } from 'lucide-react';
import { OperationType, OPERATION_BADGE_CONFIG } from '../types/auditLog';

interface OperationBadgeProps {
  operation: OperationType;
  showIcon?: boolean;
}

const OPERATION_ICONS: Record<string, React.FC<{ size?: number }>> = {
  CREATE: Plus,
  UPDATE: Edit,
  DELETE: Trash2,
  UPLOAD: Upload,
  IMPORT: FileDown,
  SYNC: RefreshCw,
  FINALIZE: CheckCircle,
  RESTORE: RotateCcw,
  OTHER: MoreHorizontal,
  ERROR: AlertTriangle,
};

const FALLBACK_CONFIG = {
  color: 'text-gray-800 dark:text-gray-200',
  bgColor: 'bg-gray-100 dark:bg-gray-700',
  text: 'DESCONHECIDO',
};

export const OperationBadge: React.FC<OperationBadgeProps> = ({
  operation,
  showIcon = true,
}) => {
  const config = OPERATION_BADGE_CONFIG[operation] || FALLBACK_CONFIG;
  const IconComponent = showIcon ? OPERATION_ICONS[operation] || null : null;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${config.color} ${config.bgColor}`}
    >
      {IconComponent && <IconComponent size={14} />}
      {config.text}
    </span>
  );
};
